import React from "react";
import { StaticAlert } from "@pearson-components/elements-sdk/build/dist.elements-sdk";

const AlertContext = React.createContext();

export class AlertProvider extends React.Component {
    state = {
        alerts: []
    };
    timer = null;

    addAlert = (message, title, type = "Success", duration = 5000) => {
        const id = Date.now();
        this.setState(
            prevState => ({
                alerts: [
                    ...prevState.alerts,
                    { id, message, title, type, duration }
                ]
            }),
            () => setTimeout(() => this.removeAlert(id), duration)
        );
    };

    removeAlert = id => {
        this.setState(prevState => ({
            alerts: prevState.alerts.filter(alert => alert.id !== id)
        }));
    };

    render() {
        const { children } = this.props;
        return (
            <AlertContext.Provider value={{ ...this.state, addAlert: this.addAlert, removeAlert: this.removeAlert }}>
                <div>
                    {this.state.alerts.map(alert => (
                        <StaticAlert
                            type={alert.type}
                            message={alert.message}
                            title={alert.title}
                        />
                    ))}
                    {children}
                </div>
            </AlertContext.Provider>
        );
    }
}

export const AlertConsumer = AlertContext.Consumer;



// WEBPACK FOOTER //
// ./src/components/context/AlertContext.js